import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React, { memo, useState } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import useLegacyProps from '../../hooks/useLegacyProps.js';
import _Box from '../Box/index.js';
import _Icon from '../Icon/index.js';

var _excluded = ["alignIcon", "children", "color", "theme", "type", "closeable", "onClose", "visible", "setVisible"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var alertColorMapping = {
  error: 'error',
  info: 'secondary',
  success: 'success',
  warning: 'warning'
};
var StyledBox = styled(_Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: none;\n  border: 4px solid\n    ", ";\n  border-radius: 0;\n  text-align: left;\n  display: flex;\n  align-items: ", ";\n"])), function (_ref) {
  var palette = _ref.theme.palette,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'success' : _ref$type;
  return palette[alertColorMapping[type]];
}, function (_ref2) {
  var _ref2$alignIcon = _ref2.alignIcon,
    alignIcon = _ref2$alignIcon === void 0 ? 'center' : _ref2$alignIcon;
  return alignIcon;
});
var StyledIcon = styled(_Icon)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-top: ", ";\n  margin-right: 0.5rem;\n"])), function (_ref3) {
  var alignIcon = _ref3.alignIcon;
  return alignIcon === 'flex-start' ? '0.125rem' : 0;
});
var StyledCloseButton = styled.button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-left: auto;\n  cursor: pointer;\n  align-self: center;\n  background: transparent;\n  border: none;\n"])));
var StyledContentDiv = styled('div')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: 'flex';\n  align-items: 'center';\n  text-align: 'left';\n  flex-wrap: 'wrap';\n"])));
var Alert = function Alert(_ref4) {
  var _ref4$alignIcon = _ref4.alignIcon,
    alignIcon = _ref4$alignIcon === void 0 ? 'center' : _ref4$alignIcon,
    children = _ref4.children,
    _ref4$color = _ref4.color,
    _ref4$theme = _ref4.theme,
    theme = _ref4$theme === void 0 ? themes["default"] : _ref4$theme,
    _ref4$type = _ref4.type,
    type = _ref4$type === void 0 ? 'success' : _ref4$type,
    closeable = _ref4.closeable,
    onClose = _ref4.onClose,
    visible = _ref4.visible,
    _ref4$setVisible = _ref4.setVisible,
    setVisible = _ref4$setVisible === void 0 ? function () {
      return null;
    } : _ref4$setVisible,
    rest = _objectWithoutProperties(_ref4, _excluded);
  var _useLegacyProps = useLegacyProps(rest),
    className = _useLegacyProps.className,
    style = _useLegacyProps.style;
  var display;
  var setDisplay; // typing got weird on this
  if (visible !== undefined) {
    display = visible;
    setDisplay = setVisible;
  } else {
    var _useState = useState(true);
    var _useState2 = _slicedToArray(_useState, 2);
    display = _useState2[0];
    setDisplay = _useState2[1];
  }
  var handleCloseIconClick = function handleCloseIconClick(e) {
    if (onClose) {
      onClose();
    }
    setDisplay(false);
  };
  if (!display) {
    return null;
  } else {
    return /*#__PURE__*/React.createElement(StyledBox, _extends({}, rest, {
      alignIcon: alignIcon,
      className: className,
      style: style,
      theme: theme,
      type: type,
      role: 'alert'
    }), /*#__PURE__*/React.createElement(StyledIcon, {
      alignIcon: alignIcon,
      color: alertColorMapping[type],
      name: type === 'error' ? 'warning' : type,
      theme: theme,
      size: 'medium'
    }), /*#__PURE__*/React.createElement(StyledContentDiv, null, children), closeable && /*#__PURE__*/React.createElement(StyledCloseButton, {
      onClick: handleCloseIconClick,
      "aria-label": "close"
    }, /*#__PURE__*/React.createElement(_Icon, {
      color: alertColorMapping[type],
      name: "close"
    })));
  }
};
var _Alert = withDefaultTheme( /*#__PURE__*/memo(Alert));

export default _Alert;
export { Alert };
